import { render, staticRenderFns } from "./RecursiveSection.vue?vue&type=template&id=a774019c&scoped=true"
import script from "./RecursiveSection.vue?vue&type=script&lang=js"
export * from "./RecursiveSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a774019c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a774019c')) {
      api.createRecord('a774019c', component.options)
    } else {
      api.reload('a774019c', component.options)
    }
    module.hot.accept("./RecursiveSection.vue?vue&type=template&id=a774019c&scoped=true", function () {
      api.rerender('a774019c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/components/RecursiveSection.vue"
export default component.exports